<mat-card class="mouter" >
    <div class="headcontent">
        <div class="pophead">
            <h3>Edit User</h3>
           
              <mat-icon (click)="close()" class="close" >close</mat-icon>
            
          </div>
        </div>
        
          <div class="dialog_content">
           
            <form [formGroup]="updateUserDetailform">
    
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>First Name</mat-label>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <input matInput placeholder="First Name" formControlName="firstname"
                            [(ngModel)]="updateUserDetail.FirstName" (keyup)="checkregex()">
                        <mat-error>
                            {{ titleAlert }}
                        </mat-error>
                    </mat-form-field>
                </div>
    
                <div fxLayout="row" fxLayoutAlign="start start">
                    
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>Last Name</mat-label>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <input matInput placeholder="Last Name" formControlName="lastname"
                            [(ngModel)]="updateUserDetail.LastName" (keyup)="checkregex()">
                        <mat-error>
                            {{ titleAlert }}
                        </mat-error>
                    </mat-form-field>
                </div>
    
                <div fxLayout="row" fxLayoutAlign="start start">
                    
     
                       
                            <mat-form-field appearance="legacy" fxFlex>
                                <mat-label>Phone</mat-label>
                                <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                                <input matInput placeholder="Phone" formControlName="phoneNumber" [(ngModel)]="updateUserDetail.PhoneNumber" mask="(000) 000-0000">
                                <mat-error>{{getPhoneErrorMessage()}}</mat-error>
                            </mat-form-field>
                      
                    
                </div>
                <!-- <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field class="form-element" fxFlex>
                        <span matPrefix>+1 &nbsp;</span>
                        <input matInput placeholder="Phone" formControlName="phoneNumber"
                            [(ngModel)]="updateUserDetail.PhoneNumber" mask="(000) 000-0000">
                        <mat-error>{{getPhoneErrorMessage()}}</mat-error>
                    </mat-form-field>
                </div> -->
    
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-list-item class="primary-imenu-item fullw" role="listitem">
                        <mat-form-field appearance="legacy" class="select-form form-element" fxFlex>
                            <mat-select placeholder="Roles" name="role" class="filter-select" formControlName="userRoles"
                                [(ngModel)]="updateUserDetail.UserRoles" [compareWith]="equals" multiple>
                                <mat-option *ngFor="let role of roles" [value]="role.name">
                                    {{role.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-list-item>
                </div>
    
                <div class="form-element">
                    <mat-checkbox formControlName="isActive" color="primary" [(ngModel)]="updateUserDetail.isActive">Active</mat-checkbox>
                </div>
            </form>
          </div>
    
    
          <div class="actionBtn">
            
            <button mat-flat-button class="cancel" (click)="close()" >Cancel</button>
            <button mat-flat-button class="calltoaction" type="submit" [disabled]="!updateUserDetailform.valid"
            (click)="updateUser()" color="primary">Update</button>
          </div>
      
</mat-card>